export const ENVIRONMENT_SCOPE_REASON_CODES_V1 = [
    "empty-scope",
    "invalid-scope-member",
    "invalid-digest",
    "duplicate-environment-id",
    "duplicate-scope-member",
    "multiple-generations-for-environment",
    "environment-scope-digest-mismatch",
    "environment-set-digest-mismatch",
];
export const ENVIRONMENT_PROJECTION_EMPTY_REASON_CODES_V1 = [
    "no-authorized-environments",
    "filter-matched-no-authorized-environments",
];
export const ENVIRONMENT_ROLLOUT_HELD_REASON_CODES_V1 = [
    "unsupported-capability",
    "grant-revoked",
    "generation-changed",
    "policy-epoch-changed",
    "identity-collision",
];
export const ENVIRONMENT_FIRST_VERIFICATION_REASON_CODES_V1 = [
    "no-verification-contract",
    "no-admissible-verification-capability",
    "policy-deferred-first-verification",
    "target-unreachable-after-activation",
];
export const ENVIRONMENT_AGENT_CONTEXT_REASON_CODES_V1 = [
    "current-host-binding-and-grant",
    "current-sandbox-binding-grant-and-lease",
    "recognized-unbound-sandbox-boundary",
    "recognized-unbound-durable-host",
    "no-single-authorized-parent",
    "conflicting-identity-or-authority-signals",
    "no-authenticated-tenant-session",
];
export const ENVIRONMENT_SCHEMA_REASON_CODES_V1 = [
    "invalid-environment-record",
];
export const ENVIRONMENT_REASON_REGISTRY_V1 = [
    ...ENVIRONMENT_SCOPE_REASON_CODES_V1,
    ...ENVIRONMENT_PROJECTION_EMPTY_REASON_CODES_V1,
    ...ENVIRONMENT_ROLLOUT_HELD_REASON_CODES_V1,
    ...ENVIRONMENT_FIRST_VERIFICATION_REASON_CODES_V1,
    ...ENVIRONMENT_AGENT_CONTEXT_REASON_CODES_V1,
    ...ENVIRONMENT_SCHEMA_REASON_CODES_V1,
];
/**
 * Versioned, deterministic precedence. The array order is the protocol order;
 * callers must not use locale-sensitive comparison or accept an unregistered
 * reason merely because another registered reason ranks ahead of it.
 */
export const ENVIRONMENT_REASON_PRECEDENCE_V1 = ENVIRONMENT_REASON_REGISTRY_V1;
const reasonRank = new Map(ENVIRONMENT_REASON_REGISTRY_V1.map((reasonCode, index) => [
    reasonCode,
    index,
]));
const reasonSet = new Set(ENVIRONMENT_REASON_REGISTRY_V1);
export function isEnvironmentReasonCode(value) {
    return reasonSet.has(value);
}
export function rankEnvironmentReasonCodes(reasonCodes) {
    if (reasonCodes.length === 0) {
        throw new Error("at least one environment reason code is required to resolve precedence");
    }
    for (const reasonCode of reasonCodes) {
        if (!isEnvironmentReasonCode(reasonCode)) {
            throw new Error(`unregistered environment reason code: ${reasonCode || "<empty>"}`);
        }
    }
    return [...new Set(reasonCodes)].sort((left, right) => (reasonRank.get(left) ?? -1) - (reasonRank.get(right) ?? -1));
}
export function resolveEnvironmentReasonCode(reasonCodes) {
    return rankEnvironmentReasonCodes(reasonCodes)[0];
}
